import React, { FC, useEffect, useRef } from 'react'
import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'
import { useFloor } from '@providers/mapProvider'
import { useParams } from '@reach/router'
import cx from 'classnames'
import { PageContent, Flex, GhostButton } from '@ui'
import { goBack } from '@utils/goTo'
import { useGetElementImage, useUser, ImageFormatE } from '@hooks'
import Map from '../AdminFloorPlan/Map'
import Appbar from '../Appbar'
import { Export } from './components'
import css from './printMap.module.scss'
import useLocations from '../UI/selects/LocationSelect/useLocations'
import { findFloor } from '../UI/selects/LocationSelect/useSelection'

const PrintMap: FC<React.PropsWithChildren<unknown>> = () => {
  const param = useParams()
  const user = useUser()
  const floor = useFloor()
  const regions = useLocations()
  const currentFloor = findFloor(floor.floorId, regions)
  const mapWrapperRef = useRef<HTMLDivElement>(null)
  const { downloadImage, isLoading } = useGetElementImage(
    `${currentFloor?.building.name}-${currentFloor?.name}`
  )

  useEffect(() => {
    if (floor.init && (!floor.floorId || !floor.apId)) {
      floor.init({ floorId: param.floorId, apId: param.apId })
    }
  }, [param, floor])

  const downloadImageHandler = (fileExtension: ImageFormatE) =>
    downloadImage(mapWrapperRef.current, fileExtension)

  return (
    <>
      <Appbar title="" />
      <PageContent>
        <Flex className={css.tool_bar} align="center" justify="space-between">
          <GhostButton iconName="long-arrow-left" text="Back" onClick={goBack} />
          <Export isLoading={isLoading} onDownloadClick={downloadImageHandler} />
        </Flex>
        <DndProvider {...{ backend: HTML5Backend }}>
          <Map
            ref={mapWrapperRef}
            key={`${floor.floorId}-${floor.apId}`}
            floor={floor}
            user={user.user}
            showMapActions={false}
            wrapperClassName={cx(css.print_map_container)}
            bottomMapContainerElement={
              <div className={css.export_notification__container}>
                <span className={css.export_notification__title}>Image to export</span>
              </div>
            }
          />
        </DndProvider>
      </PageContent>
    </>
  )
}

export default PrintMap
